import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { KeyRound, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/concierge`;

export const ConciergeSettings = ({ headers }) => {
  const [form, setForm] = useState({ name: "", username: "", password: "" });
  const [hasAccount, setHasAccount] = useState(false);
  const link = `${window.location.origin}/etoile`;

  useEffect(() => {
    axios.get(`${API}/settings`, { headers }).then((r) => {
      setForm({ name: r.data.name || "", username: r.data.username || "", password: "" });
      setHasAccount(!!r.data.username);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const save = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API}/settings`, { ...form, password: form.password || null }, { headers });
      toast.success("Accès enregistré");
      setHasAccount(true);
      setForm({ ...form, password: "" });
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur");
    }
  };

  const copy = () => { navigator.clipboard.writeText(link); toast.success("Lien copié"); };

  return (
    <form onSubmit={save} className="bg-white rounded-xl border p-4 space-y-3" data-testid="concierge-settings-form">
      <h2 className="font-bold flex items-center gap-2"><KeyRound className="w-5 h-5 text-pink-600" />Accès de la conciergerie</h2>
      <div className="flex gap-2 items-center bg-slate-50 rounded-lg p-2 text-sm">
        <span className="flex-1 truncate" data-testid="concierge-link">{link}</span>
        <Button type="button" variant="outline" size="sm" onClick={copy} data-testid="concierge-copy-link-btn"><Copy className="w-4 h-4 mr-1" />Copier le lien</Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
        <Input placeholder="Nom de la conciergerie" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required data-testid="concierge-settings-name" />
        <Input placeholder="Identifiant" value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} required data-testid="concierge-settings-username" />
        <Input type="password" placeholder={hasAccount ? "Nouveau mot de passe (optionnel)" : "Mot de passe"} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="concierge-settings-password" />
      </div>
      <Button type="submit" className="bg-pink-600 hover:bg-pink-700" data-testid="concierge-settings-save-btn">Enregistrer</Button>
    </form>
  );
};
